const FR = {
  'outlander-2025.interior.image-1.hotspot-1.label': 'Volant et tableau de bord',
  'outlander-2025.interior.image-1.hotspot-1.message': 'Volant et tableau de bord',
  'outlander-2025.interior.image-1.hotspot-2.label': 'Contrôle de la climatisation',
  'outlander-2025.interior.image-1.hotspot-2.message': 'Contrôle de la climatisation',
  'outlander-2025.interior.image-1.hotspot-3.label': 'Levier de vitesses et console centrale',
  'outlander-2025.interior.image-1.hotspot-3.message': 'Levier de vitesses et console centrale',
  'outlander-2025.interior.image-1.hotspot-4.label': 'Siège du conducteur',
  'outlander-2025.interior.image-1.hotspot-4.message': 'Siège du conducteur',

  'outlander-2025.interior.image-2.hotspot-1.label': 'Sièges rabattables de la 3e rangée',
  'outlander-2025.interior.image-2.hotspot-1.message': 'Sièges rabattables de la 3e rangée',
  'outlander-2025.interior.image-2.hotspot-2.label':
    'Ceintures de sécurité et dispositifs de retenue',
  'outlander-2025.interior.image-2.hotspot-2.message':
    'Ceintures de sécurité et dispositifs de retenue',
  'outlander-2025.interior.image-2.hotspot-3.label': 'Caractéristiques de sécurité active',
  'outlander-2025.interior.image-2.hotspot-3.message': 'Caractéristiques de sécurité active',
  'outlander-2025.interior.image-2.hotspot-4.label': 'Commodités de la 2e rangée',
  'outlander-2025.interior.image-2.hotspot-4.message': 'Commodités de la 2e rangée',

  'outlander-2025.exterior.hotspot-1.label': 'Moteur et transmission',
  'outlander-2025.exterior.hotspot-1.message': 'Moteur à injection directe de 2,5 L à 4 cylindres',
  'outlander-2025.exterior.hotspot-2.label': 'Technologie de conduite à quatre roues motrices',
  'outlander-2025.exterior.hotspot-2.message':
    'Contrôle intégral des quatre roues motrices (S-AWC) avec sélecteur de mode de conduite',
  'outlander-2025.exterior.hotspot-3.label': "Système d'entrée et de démarrage",
  'outlander-2025.exterior.hotspot-3.message': "Système d'entrée et de démarrage",
  'outlander-2025.exterior.hotspot-4.label': 'Roues et pneus',
  'outlander-2025.exterior.hotspot-4.message': 'Roues et pneus',
  'outlander-2025.exterior.hotspot-5.label': 'Caractéristiques arrière',
  'outlander-2025.exterior.hotspot-5.message': 'Caractéristiques arrière',
  'outlander-2025.exterior.hotspot-6.label': 'Pare-chocs et plaque de protection',
  'outlander-2025.exterior.hotspot-6.message': 'Pare-chocs et plaque de protection',
  'outlander-2025.exterior.hotspot-7.label': 'Hayon et bouchon de réservoir',
  'outlander-2025.exterior.hotspot-7.message': 'Hayon et bouchon de réservoir',
  'outlander-2025.exterior.hotspot-8.label': 'Rétroviseurs latéraux et poignées de porte',
  'outlander-2025.exterior.hotspot-8.message': 'Rétroviseurs latéraux et poignées de porte',
  'outlander-2025.exterior.hotspot-9.label': 'Fenêtres et essuie-glaces',
  'outlander-2025.exterior.hotspot-9.message': 'Fenêtres et essuie-glaces',

  'outlander-2025.blueprint.safety.tab-1': 'Rideaux et sièges',
  'outlander-2025.blueprint.safety.tab-2':
    'Coussin gonflable SRS pour les genoux de la première rangée',
  'outlander-2025.blueprint.safety.hotspot-1.label': 'Coussin gonflable rideau latéral',
  'outlander-2025.blueprint.safety.hotspot-1.message': 'Coussin gonflable rideau latéral',
  'outlander-2025.blueprint.safety.hotspot-2.label': 'Coussin gonflable latéral monté sur le siège',
  'outlander-2025.blueprint.safety.hotspot-2.message': 'Coussin gonflable monté sur le siège',
  'outlander-2025.blueprint.safety.hotspot-3.label':
    'Coussin gonflable central\nmonté sur le siège avant',
  'outlander-2025.blueprint.safety.hotspot-3.message':
    'Coussin gonflable central monté sur le siège avant',
  'outlander-2025.blueprint.safety.hotspot-4.label': 'Siège du conducteur',
  'outlander-2025.blueprint.safety.hotspot-4.message': 'Siège du conducteur',
  'outlander-2025.blueprint.safety.hotspot-5.label': 'Siège du passager avant',
  'outlander-2025.blueprint.safety.hotspot-5.message': 'Siège du passager avant',

  'outlander-2025.launcher.introduction': "Cliquez pour poser des questions sur 2025 l'Outlander",
}

export default FR
